import base from "./base"

export default (store, credentials) => {
  // @ts-expect-error TS2345
  return base(store, {
    data: { credentials },
    methods: {
      open_files: store.open,
      open_folders: store.open,
      refresh() {
        this.populate()
      },
    },
  })
}
